import { Badge } from '@radix-ui/themes'
import { compatibilityStatusColor, compatibilityStatusLabel, type CompatibilityStatus } from '../constants'

interface CompatibilityBadgeProps {
  status: CompatibilityStatus
  size?: '1' | '2'
}

export const CompatibilityBadge = ({ status, size = '1' }: CompatibilityBadgeProps) => (
  <Badge color={compatibilityStatusColor[status]} variant="soft" size={size}>
    {compatibilityStatusLabel[status]}
  </Badge>
)
